import { ApplicationErrorType } from "./application-error.types";

export abstract class ApplicationError extends Error
{
    //#region Constructor

    /**
     * Class constructor
     * @param errorMessage text description of error
     * @param errorType application error type
     * @param device device info
     * @param applicationVersion application version
     * @param softwareVersion os version
     * @param userAgent agent used (android, ios)
     */
    constructor
        (
            errorMessage,
            errorType: ApplicationErrorType,
            device: string,
            applicationVersion,
            softwareVersion,
            userAgent: string,
        )
    {
        super(errorMessage);

        this.ErrorMessage = errorMessage;
        this.ErrorType = errorType;
        this.Device = device;
        this.ApplicationVersion = applicationVersion;
        this.SoftwareVersion = softwareVersion;
        this.UserAgent = userAgent
    }

    //#endregion 

    //#region Properties

    /**
     * Error message
     */
    public ErrorMessage;
    
    /**
     * Error Type
     */
    public ErrorType: ApplicationErrorType;

    /**
     * Device type
     */
    public Device: string;

    /**
     * Application version
     */
    public ApplicationVersion

    /**
     * Software version
     */
    public SoftwareVersion;

    /**
     * User Agent
     */
    public UserAgent: string;

    //#endregion

    //#region Methods

    /**
     * Convert the exception to an object
     */
    public toObject(): any
    {
        let object: { [id: string]: any } = {};

        for (var prop in this)
        {
            object[prop] = this[prop];
        }

        return object;
    }
    //#endregion
}
